<template>
  <div class="leavehospitalapproval">
    <el-row>
      <el-form
        v-if="showFlag"
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        :size="size"
        @submit.native.prevent
      >
        <el-form-item
          :label="leaveHospital.oldmanName"
          style="margin-left: 30px"
        >
          <el-input
            v-model.trim="formInline.oldmanName"
            :placeholder="leaveHospital.enterName"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-search"
            :label="leaveHospital.search"
            type="primary"
            @click="serach"
          />
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <!--表格内容栏-->
      <el-table
        style="width: 100%"
        :data="tableData"
        :loading="tableLoading"
        :border="false"
        :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          prop="oldmanName"
          :label="leaveHospital.oldmanName"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="idCard"
          :label="leaveHospital.idCard"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="sex"
          :label="leaveHospital.sex"
          min-width="50"
        ></el-table-column>
        <el-table-column
          prop="birthday"
          :label="leaveHospital.birthday"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="leaveDate"
          :label="leaveHospital.leaveDate"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="stateX"
          :label="leaveHospital.state"
          min-width="100"
        ></el-table-column>
        <el-table-column :label="leaveHospital.operator" min-width="200">
          <template slot-scope="scope">
            <!-- <a
              @click="handlePass(scope.$index, scope.row)"
              class="curcor marginR10"
            >
              <img
                class="handedness"
                src="@/assets/beadhouse/shenhe.png"
              />
            </a> -->
            <!-- <a
              v-if="
                roleCode == 'medicalMinister' ||
                roleCode == 'receptionist' ||
                roleCode == 'receptionMinister' ||
                roleCode == 'evaluate'
              "
              @click="handleNopass(scope.$index, scope.row)"
              class="curcor marginR10"
            >
              <img class="handedness" src="@/assets/beadhouse/shanc.png" />
            </a> -->
            <!-- <a @click="handleLook(scope.$index, scope.row)" class="curcor marginR10">
              <img class="handedness" src="@/assets/beadhouse/chakan_icon.png" />
            </a> -->
            <el-button
              type="primary"
              size="mini"
              plain
              icon="el-icon-circle-check-outline"
              @click="handlePass(scope.$index, scope.row)"
              >通过</el-button
            >
            <el-button
              type="warning"
              size="mini"
              plain
              icon="el-icon-circle-check-outline"
              @click="handleNopass(scope.$index, scope.row)"
              >不通过</el-button
            >
            <el-button
              @click="handleLook(scope.$index, scope.row)"
              size="small"
              plain
              type="success"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next"
        :total="totalDataNumber"
        :page-size="pageSize"
        align="center"
        class="fenye"
      ></el-pagination>
    </el-row>
    <el-dialog
      :title="leaveHospital.titleInfo"
      :visible.sync="dialogVisible"
      width="30%"
      center
    >
      <el-form
        :inline="true"
        :model="dataForm"
        ref="dataForm"
        :rules="dataFormRules"
        class="demo-form-inline"
        label-width="130px"
      >
        <el-form-item label="">
          <span style="margin: 20px 120px; text-align: center">{{
            leaveHospital.title
          }}</span>
        </el-form-item>
        <el-form-item :label="leaveHospital.reason" prop="comment">
          <el-input
            v-model.trim="dataForm.comment"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitNopass">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "LeaveHospitalApproval",
  props: {
    showFlag: {
      type: Boolean,
      default: true,
    },
  },
  components: { KtButton },
  data() {
    return {
      leaveHospital: {
  oldmanName: "老人姓名",
  enterName: "请输入姓名",
  search: "查询",
  add: "添加",
  idCard: "身份证号",
  sex: "性别",
  birthday: "生日",
  leaveDate: "出院时间",
  state: "状态",
  operator: "操作",
  addLeaveApply: "添加出院申请",
  fuzzySearchOldman: "模糊搜索老人",
  selectDate: "选择日期",
  leaveReason: "出院原因",
  please: "请选择",
  deathReason: "死亡原因",
  deathDate: "死亡日期",
  itemName: "类别",
  money: "金额",
  remark: "备注",
  titleInfo: "信息提示",
  reason: "原因",
  title: "你确定不通过出院申请吗?",
  back: "返回",
  dischargeNotice: "出院通知单",
  baseInfo: "基本信息",
  inDate: "入院时间"
}, //引入 lang 里面的字符串资源
      loading: true,
      size: "medium", //按钮的尺
      formInline: {
        oldmanName: "",
      },
      tableData: [], //表格数据
      tableLoading: false, //表格加载的loading
      /* 分页的 */
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      roleCode: "", //角色code
      /* 审批不通过的dialog */
      dialogVisible: false,
      dataFormRules: {
        comment: [
          {
            required: true,
            message: "请输入老人出院申请不通过原因",
            trigger: "blur",
          },
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
        ],
      },
      dataForm: {
        comment: "",
      },
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //查询按钮
    serach() {
      if (this.formInline.oldmanName == "") {
        this.queryListWithPage(this.formInline.oldmanName, (this.pageNum = 1));
      } else {
        this.queryListWithPage(
          this.formInline.oldmanName,
          (this.pageNum = 1),
          (this.pageSize = 10)
        );
      }
    },
    //enter键查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        if (this.formInline.oldmanName == "") {
          this.queryListWithPage(
            this.formInline.oldmanName,
            (this.pageNum = 1)
          );
        } else {
          this.queryListWithPage(
            this.formInline.oldmanName,
            (this.pageNum = 1),
            (this.pageSize = 10)
          );
        }
      }
    },
    //出院申请 查看详情
    handleLook(index, row) {
      console.log(index, row);
      console.log("跳转到出院申请详情页面");
      sessionStorage.setItem("leaveHospitalType", 2); //出院申请审批是leaveHospitalType=2
      bus.$emit("homePage", {
        type: "jump",
        path: "/LeaveHospitalDetail",
        title: "出院申请详情",
        params: {
          oldOutRow: row,
        },
      });
    },
    //审批通过
    handlePass(index, row) {
      console.log(index, row);
      this.$confirm("你确定通过出院申请吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          var params = new Object();
          params.id = row.id; //服务审批公共的参数  所有审批都需要的
          var url = "";
          console.log(params, "params");
          //by guo 2019-11-15-18:21修改
          //1 未提交 2 申请中 3 接待审核 4 审核未通过 5 收费室确认 6 服务部确认 7 医疗部确认
          switch (row.state) {
            //服务部长
            case 2:
              url = "omc/oldOut/serviceConfirm";
              break;
            //医疗部长
            case 6:
              params.state = 1; //state---0  不同意    state----1  同意
              url = "omc/oldOut/medicalApproval";
              break;
            //接待员  接待部长
            case 7:
              params.state = 1; //state---0  不同意    state----1  同意
              url = "omc/oldOut/admitApproval";
              break;
            //收费员
            case 3:
              url = "omc/oldOut/chargeConfirm";
              break;
          }
          this.$postJson(url, params).then((res) => {
            console.log(res, "====");
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.message,
              });
              this.queryListWithPage(); //刷新列表的数据
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消审批",
          });
        });
    },

    /* 
      审批不通过弹出模态框
    */
    handleNopass(index, row) {
      console.log(index, row);
      this.$nextTick(() => {
        if (this.$refs.dataForm != undefined) {
          this.$refs.dataForm.resetFields();
        }
      });
      this.dialogVisible = true;
      this.dataForm = Object.assign({}, row);
      console.log(this.dataForm);
    },

    /*  
      审批不通过提交数据
    */
    submitNopass() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          console.log(this.dataForm);
          console.log(this.dataForm.comment);
          let params = new Object();
          params.id = this.dataForm.id * 1;
          params.state = 0; //state----0 不通过  state----1 通过
          params.comment = this.dataForm.comment;
          //区分 医疗部 和 接待室
          var url = "";
          switch (this.roleCode) {
            case "medicalMinister":
              url = "omc/oldOut/medicalApproval";
              break;
            default:
              url = "omc/oldOut/admitApproval";
          }
          console.log(params, url);
          this.$postJson(url, params).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.dialogVisible = false; //关闭dialog模态框
              this.queryListWithPage(); //刷新列表的数据
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        }
      });
    },

    /* 
      查询老人出院待审批列表
    */
    queryListWithPage() {
      let params = {};
      if (this.formInline.oldmanName != "" || null || undefined) {
        params.oldmanName = this.formInline.oldmanName;
      }
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableData = []; //请求之前先清空数据
      this.tableLoading = true;
      console.log(params);
      this.$postJson("omc/oldOut/queryCurTask", params).then((res) => {
        console.log(res, "----");
        if (res.code == 200) {
          if (res.result.list != null) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            //循环遍历处理数据
            res.result.list.forEach((item) => {
              var object = {};
              object = Object.assign({}, item);
              object.sex = item.sex == 0 ? "男" : "女";
              switch (item.state) {
                case 1:
                  object.stateX = "未提交";
                  break;
                case 2:
                  object.stateX = "申请中";
                  break;
                case 3:
                  object.stateX = "接待室审核通过";
                  break;
                case 4:
                  object.stateX = "审核未通过";
                  break;
                case 5:
                  object.stateX = "收费室确认";
                  break;
                case 6:
                  object.stateX = "服务部确认";
                  break;
                default:
                  object.stateX = "医疗部审核通过";
              }
              this.tableData.push(object);
            });
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
        } else {
          this.tableData = [];
          this.pageSize = 10;
          this.currentPage = 1;
          this.totalDataNumber = 0;
        }
        setTimeout(() => {
          this.tableLoading = false;
        }, 1000);
      });
    },

    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.queryListWithPage();
    },

    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.queryListWithPage();
    },
  },
  created() {
    this.roleCode = sessionStorage.getItem("roleCode");
  },
  mounted() {
    this.queryListWithPage();
    //by guo 2019-11-14-19:15添加  监听刷新表格的数据
    //监听 待办事项页面的
    this.$bus.$on("refreshLeaveHospital", () => {
      console.log("待办事项页面传来的");
      this.queryListWithPage(); //刷新列表的数据
    });
  },
};
</script>
<style lang="scss" scoped>
.leavehospitalapproval {
  width: 100%;
  height: 100%;
  background: #fefefe;
  .marginR10 {
    margin-right: 10px;
  }
}
// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>

